<div class="modal-header border-light">
    <div class="modal-title pull-left d-flex">
        <h3 class="mb-0 font-weight-bold">All Notes <span class="color--light--gray">{{allNoteCount}}</span></h3>
    </div>

    <button id="show-note-modal-close-btn" type="button" class="close pull-right align-self-center" aria-label="Close"
        (click)="showNoteBsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body p-0">

        <div class="notes-modal__itemGroup custom__scroll">
            <div class="note" *ngFor="let note of allNotesList; index as i">
                <div class="content">
                    <div class="title-group">
                        <div class="title">
                            <span class="title-name">{{note?.CREATED_BY?.NAME_FIRST}}
                                {{note?.CREATED_BY?.NAME_LAST}}</span>
                            <span class="date">{{note.CREATED_FORMATTED}}</span>
                        </div>
                    </div>
                    <span class="comment-text">{{note.TEXT}}</span>
                    <div class="pin-frame" *ngIf="note.PAGE">
                        <span class="include-text">{{note.PAGE.NAME}}</span>
                        <div class="pin" *ngIf="note.INCLUDE_IN_REPORT">
                            <svg-icon name="pin"></svg-icon>
                        </div>
                    </div>
                </div>
                <div class="photo">
                    <img class="rounded-circle" [src]="note?.CREATED_BY?.THUMBNAIL_IMAGE" width="50" height="50"
                        onerror="this.src='../../../../../assets/images/profilePhoto.jpg';" alt="...">
                </div>
            </div>
        </div>

</div>
